import { TXsollaSubscriptionTier } from '../../../common/xsollaConfig';

// Maps tier slug to the WoW item-quality color class so tier identity is
// consistent across the rail, settings page, and success page.
//   Revered → Epic (purple)
//   Exalted → Legendary (orange)
//   Illustrious → Artifact (cream/gold)
export const TIER_TEXT_CLASS: Record<TXsollaSubscriptionTier, string> = {
  revered: 'text-item-quality--4',
  exalted: 'text-item-quality--5',
  illustrious: 'text-item-quality--6'
};
